module.exports = __webpack_public_path__ + "img/34.999aed7d.png";